import React, { Component } from 'react'
import * as yup from 'yup';
import { Formik } from 'formik';
import { BTInputField } from '../../globals/uicomps/BTInputField';
import { withTranslation } from 'react-i18next';

class ForgotPassword extends Component {
     constructor(props) {
          super(props)

          this.state = {
               userName: '', email: '', toLogin: false, loginDetails: ""
          }
          this.schema = yup.object().shape({
               userName: yup.string().required("Username is required"),
               email: yup.string().email("Invalid email").required("Email is required")
          });
     }

     submitDetails = (values) => {
          this.props.forwardToOtp(values.userName, values.email)
     }


     render() {
          const { t } = this.props;
          return (
               <React.Fragment>
                    <div className="sub-heading1 text-center">{t('Enter your details')}</div>
                    <div className="clr20"></div>

                    <Formik validationSchema={this.schema} onSubmit={this.submitDetails} initialValues={this.state}>
                         {
                              ({ handleSubmit, handleChange, handleBlur, values, touched, isValid, errors }) => (
                                   <form onSubmit={handleSubmit} noValidate autoComplete="off">

                                        <BTInputField label={t('Username')} id="userName" handleBlur={handleBlur}
                                             handleChange={handleChange} value={values.userName} required={true}
                                             errors={errors} touched={touched} autoComplete="off" />

                                        <BTInputField label={t('Email')} id="email" handleBlur={handleBlur}
                                             handleChange={handleChange} value={values.email} required={true}
                                             errors={errors} touched={touched} autoComplete="off" />

                                        <input className="btn btn_primary block" type="submit"
                                             value="Continue" disabled={!(values.userName && values.email)} ></input>

                                        <div className="forgetlink body2 right mt10 pointer" onClick={() => { this.props.changeStepValue("login") }}>{t('Back to Login')}</div>

                                   </form>
                              )
                         }
                    </Formik>
               </React.Fragment>
          )
     }
}
export default withTranslation('translations')(ForgotPassword);

